import React from 'react'
import "./About.css";
import about_img from "../../assets/about.png";
import play_icon from "../../assets/play-icon.png";

export default function About({setPlayState}) {
  return (
    <div className='about'>
        <div className="about-left">
            <img src={about_img} alt="" className='about-img' />
            <img src={play_icon} alt="" className='play-icon' onClick={()=>{setPlayState(true)}}  />

        </div>
        <div className="about-right">
            <h3>About University</h3>
            <h2>Nurturing Tommorow's Leaders Todaay </h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                Ipsa porro, culpa dolor minus reprehenderit, laboriosam nesciunt velit necessitatibus
                 nemo quas impedit repellat ducimus quibusdam perspiciatis a tempore quam quod maxime?</p>
                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                Ipsa porro, culpa dolor minus reprehenderit, laboriosam nesciunt velit necessitatibus
                 nemo quas impedit repellat ducimus quibusdam perspiciatis a tempore quam quod maxime?</p>
                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                Ipsa porro, culpa dolor minus reprehenderit, laboriosam nesciunt velit necessitatibus
                 nemo quas impedit repellat ducimus quibusdam perspiciatis a tempore quam quod maxime?</p>
        </div>

    </div>
  )
}
